import React from "react";
import ReactToPrint from "react-to-print";
import { NumericFormat } from 'react-number-format';
import { MDBTable, MDBTableBody } from 'mdbreact';
import { useRef } from "react";
import {
  calcularEnvioFactura,
  getDisplayUnitPrice,
  getQuantity,
  obtenerTotalesPedido,
  toNumber
} from '../../../../utils/totalesPedido';

export const ComponentToPrint = React.forwardRef((props, ref) => {
  const datosFactura = props.datosFactura

  // console.log('datosFactura?.datosPago?', datosFactura)

const totalesPedido = obtenerTotalesPedido(datosFactura);

const calcularDescuento = () => totalesPedido.descuento > 0
  ? totalesPedido.descuento
  : Number(Math.max(0, totalesPedido.subtotalLineas - totalesPedido.subtotalNeto).toFixed(2));

const calcularEnvio = () => calcularEnvioFactura(datosFactura);

const getCashPayment = () => (
  datosFactura?.datosPago?.mediosPagoPasarela?.find((payment) => payment.medioPagoNombre === 'Efectivo')
);

const getDisplayedReceivedAmount = () => {
  const cashPayment = getCashPayment();
  if (toNumber(cashPayment?.importe) > 0) return toNumber(cashPayment.importe);

  const importe = toNumber(datosFactura?.datosPago?.importe);
  if (importe > 0) return importe;

  return toNumber(datosFactura?.datosPago?.total);
};

  return (
    <div className="cont_tiket" ref={ref}>
      <h4>Blue Moon Beauty SD INC</h4>
      <span>Principal</span><br />
      <span>https://bluemoonbeautysd.com</span><br />
      <hr className="lineaFactura" />

      <span>Factura: {datosFactura?.codigo ? datosFactura.codigo : `BLUE-${datosFactura.id}`}</span><br />
      <span>Vendedor: {datosFactura?.datosPago?.vendedor ? datosFactura.datosPago.vendedor : 'App/Página Web'}</span><br />
      <span>Fecha y hora: {datosFactura.fecha}</span><br />
      <hr className="lineaFactura" />

      <div className="combina_tiquete" style={{ textAlign: 'left' }}>
        <span>Cliente: {datosFactura.cliente.nombre}</span><br />
        <span>Teléfono: {datosFactura.cliente.tel}</span><br />
        <span>Dirección: {datosFactura.cliente.direccion}</span><br />
        <span>Email: {datosFactura.cliente.email}</span><br />
      </div>
      <hr className="lineaFactura" />

      <span>DETALLE DEL PEDIDO:</span><br />

      <div>
        <MDBTable responsive>
          <MDBTableBody>
            <tr className="tabla_tiquete">
              <td></td>
              <td>Productos:</td>
              <td>V. Unitario:</td>
              <td>Total:</td>
            </tr>
            {datosFactura.pedido.map((item, index) => (
              <tr className="tabla_tiquete" key={index}>
                <td>{getQuantity(item)}</td>
                <td>{item.nombre_producto}</td>
                <td><NumericFormat value={getDisplayUnitPrice(item)} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
                <td>
                  <NumericFormat
                    value={getDisplayUnitPrice(item) * getQuantity(item)}
                    displayType="text"
                    thousandSeparator={true}
                    prefix="$"
                    decimalScale={2}
                    fixedDecimalScale={true}
                  />
              
                  </td>
              </tr>
            ))}
            <tr className="tabla_tiquete">
              <td></td>
              <td></td>
              <td style={{ borderTop: '2px solid #000' }}>SUBTOTAL:</td>
              <td><NumericFormat decimalScale={2} value={totalesPedido.subtotalBruto} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
              </tr>
          </MDBTableBody>
        </MDBTable>
      </div>

      {/* <span>SUBTOTAL: <NumericFormat decimalScale={2} value={parseFloat(datosFactura.datosPago.subtotal)} displayType={'text'} thousandSeparator={true} prefix={'$'} /> </span><br /> */}
      <hr className="lineaFactura" />

      <span>DATOS DE PAGO:</span><br />
      <MDBTable responsive>
        <MDBTableBody>
          {/* {datosFactura.datosPago.medio !== 'Efectivo' && (
            <tr className="tabla_tiquete">
              <td>NOMBRE IMPUESTO:</td>
              <td><span><NumericFormat decimalScale={2} value={datosFactura.datosPago.impuesto_nombre} displayType={'text'} thousandSeparator={true} prefix={'$'} /> </span> <br /></td>
            </tr>
          )} */}

          <tr className="tabla_tiquete">
            <td>DESCUENTO:</td>
            <td>
              <span>
                <NumericFormat
                  value={calcularDescuento()}
                  displayType="text"
                  thousandSeparator
                  prefix="$"
                  decimalScale={2}
                  fixedDecimalScale
                />
              </span>
            </td>
            
          </tr>

          <tr className="tabla_tiquete">
            <td>SUBTOTAL:</td>
            <td><span><NumericFormat decimalScale={2} value={totalesPedido.subtotalBruto} displayType={'text'} thousandSeparator={true} prefix={'$'} /> </span> <br /></td>
            
          </tr>
          <tr className="tabla_tiquete">
            <td>TAX:</td>
            <td>
              <span>
                <NumericFormat decimalScale={2} value={totalesPedido.taxes} displayType={'text'} thousandSeparator={true} prefix={'$'} />
              </span> <br /></td>
          </tr>
          {/* {datosFactura.canal === 'Facturación' ?
            <tr className="tabla_tiquete">
              <td>FEE:</td>
              <td><span><NumericFormat decimalScale={2} value={datosFactura.datosPago.fee} displayType={'text'} thousandSeparator={true} prefix={'$'} /> </span> <br /></td>
            </tr>
            :null
          } */}
          {datosFactura?.datosPago?.totalCargas && datosFactura.datosPago.totalCargas > 0 && datosFactura.canal !== 'Facturación'?
            <tr className="tabla_tiquete">
              <td>ENVIO: {datosFactura.canal}</td>
              <td><span><NumericFormat decimalScale={2} value={calcularEnvio()} displayType={'text'} thousandSeparator={true} prefix={'$'} /> </span> <br /></td>
            </tr>
          :null}
          {datosFactura.canal === 'Facturación'?
              <tr className="tabla_tiquete">
                <td>IMPORTE RECIBIDO:</td>
                <td><span><NumericFormat decimalScale={2} value={getDisplayedReceivedAmount()} displayType={'text'} thousandSeparator={true} prefix={'$'} /> </span> <br /></td>
              </tr>
              :null
          }

          {datosFactura.canal === 'Facturación' ?
              <tr className="tabla_tiquete">
                <td>CAMBIO:</td>
                <td><span><NumericFormat decimalScale={2} value={datosFactura.datosPago.cambio} displayType={'text'} thousandSeparator={true} prefix={'$'} /> </span> <br /></td>
              </tr>
              :null
          }
          
          <tr className="tabla_tiquete">
            <td>TOTAL:</td>
            <td><span><NumericFormat decimalScale={2} value={totalesPedido.total} displayType={'text'} thousandSeparator={true} prefix={'$'} /> </span> <br /></td>
          </tr>

        </MDBTableBody>
      </MDBTable>
      <hr className="lineaFactura" />



      {datosFactura?.datosPago?.mediosPagoPasarela?.length > 0 ?
        <div>
          <span>MEDIOS DE PAGO:</span><br />

          <MDBTable responsive>
            <MDBTableBody>
              <tr className="tabla_tiquete">
                <td>MEDIO:</td>
                <td>IMPORTE:</td>
                <td>TAX:</td>
                {/* <td>FEE:</td> */}
                <td>TOTAL:</td>
              </tr>
              {datosFactura?.datosPago?.mediosPagoPasarela.map(item =>

                item.importe + item.interes > 0 ?

                  item.medioPagoNombre === 'Efectivo' ?
                    (
                      <tr className="tabla_tiquete">
                        <td>{item.medioPagoNombre}</td>
                        <td><NumericFormat value={item.importe} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} /> </td>
                        <td><NumericFormat value={item.interes} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} /></td>
                        {/* <td><NumericFormat value={item.tarifaPorcentaje} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} /> </td> */}
                        <td><NumericFormat value={item.importe + item.interes + item.tarifaPorcentaje} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} /> </td>
                      </tr>
                    )
                    :
                    (
                      <tr className="tabla_tiquete">
                        <td>{item.medioPagoNombre}</td>
                        <td><NumericFormat value={item.importe} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} /> </td>
                        <td><NumericFormat value={item.interes} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} /></td>
                        {/* <td><NumericFormat value={item.tarifaPorcentaje} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} /> </td> */}
                        <td><NumericFormat value={(item.importe + item.interes + item.tarifaPorcentaje)} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} /> </td>
                      </tr>
                    )
                  : null
              )}
            </MDBTableBody>
          </MDBTable>
        </div>
      :

        <>
          {datosFactura.canal === 'Facturación' ?
              <div>
              <span>DATOS DE PAGO:</span><br />
              <div className="combina_tiquete" style={{ textAlign: 'left' }}>
                <span>MEDIO: {datosFactura.datosPago.medio}</span><br />
                {datosFactura.datosPago.medio !== 'Efectivo' && (<>  <span>REFERENCIA: {datosFactura.datosPago.referencia}</span><br /></>)}
                <span>RECIBIDO: <NumericFormat value={getDisplayedReceivedAmount()} displayType={'text'} thousandSeparator={true} prefix={'$'} /></span><br />
                
                <span>CAMBIO: <NumericFormat decimalScale={2} value={datosFactura.datosPago.cambio} displayType={'text'} thousandSeparator={true} prefix={'$'} /></span><br />
              </div>
            </div>
              :null
          }
        
        </>

      }

      <hr className="lineaFactura" />
      <span>TOTAL A PAGAR: </span>
      <NumericFormat decimalScale={2} value={datosFactura.datosPago.total} displayType={'text'} thousandSeparator={true} prefix={'$'} />
      <br />



      <hr className="lineaFactura" />
      <span>Impreso por:</span><br />
      <span>Tecnosoluciones y Software</span><br />
      <span>www.tecnosolagencia.com - (+57) 315 415 5690</span><br />
      <hr className="lineaFactura" />
      <span>No se hacen devoluciones ni cambios de productos</span><br />
      <br />
      <span></span><br /><span></span><br />

    </div>
  );
});

const Tiquete = ({ datosFactura, selectDomi }) => {
  const componentRef = useRef();
  return (
    <div>
      <center>
        <ReactToPrint
          trigger={() =>
            <a href="#"
              className="btn boton_estandar"
            >Imprimir Ticket
            </a>}
          content={() => componentRef.current}
        />

      </center>
      <ComponentToPrint
        key={'111a'}
        ref={componentRef}
        datosFactura={datosFactura}
        selectDomi={selectDomi} />
    </div>
  );
}

export default Tiquete;
